import axios from '@/utils/axios.js'

export function listModel (portId){

    const getMenu = new Promise((resolve, reject)=>{
        //得到菜单
        axios.get('/portal/vue/YfPortalServlet',{params:{
            'action': 'ArticleType',
            'typeId': portId
        }}).then(result=>{
            let menu = result
            let model =''+menu.parent.type_model
            if(menu.child.length>0){//子栏目较多的情况
                if(model=="0"){
                    model="-1"//有子类且是图文显示
                }else if(model=='1'){
                    model='-2'//有子类且是图片显示
                }
                resolve({menu,model})
            }else{
                axios.get('/portal/vue/YfPortalServlet',{params:{
                    'action': 'ArticleType',
                    'typeId': portId.slice(0,-2).length<6?portId:portId.slice(0,-2)
                }}).then(result=>{
                    menu = result
                    resolve({menu,model})
                    
                })
            }
        })

        
    })

   
    
    
    const getData =({menu,model})=>{
        return new Promise((resolve, reject)=>{
            if(["0","1",'3',"4"].indexOf(model)!=-1){
                axios.get('/portal/vue/YfPortalServlet',{params:{action:"List",contextFlg:'1',typeId:portId,currPage:"1"}}).then(result=>{
                    resolve({menu,model,data:result}) 
                })
            }else if(model=='2'){
                axios.get('/portal/vue/YfPortalServlet',{params:{action:"Index",typeId:portId,rowNum:"1",contextFlg:'2'}}).then(result=>{
                    resolve({menu,model,data:result[0].dt[0]||''}) 
                })
            }else if(["-1","-2"].indexOf(model)!=-1){
                let num = new Array();
                let listTotal =menu.child.map(function (item,index) {
                    num[index]=(model=='3'?'12':'10')
                    return item.type_id;
                });
                axios.get('/portal/vue/YfPortalServlet',{params:{'action':'Index','contextFlg':'1','typeId':listTotal.join(','),'rowNum':num.join(',')}}).then(result=>{
                    resolve({menu,model,data:result}) 
                })
            }else if(model=='5'){
                axios.get('/portal/vue/YfPortalServlet',{params:{action:"List",typeId:portId}}).then(result=>{
                    resolve({menu,model,data:result}) 
                })
            }
        })

    } 

    const getNav =({menu,model,data})=> new Promise((resolve, reject)=>{
        //得到nav
        axios.get('/portal/vue/YfPortalServlet',{params:{
            'action': 'Navigate',
            'typeId': portId
        }}).then(result=>{
            resolve({menu,model,data,nav:result})
        })
    })
   
    return getMenu.then(getData).then(getNav)

}

export function listPage(portId,currPage){
    return new Promise((resolve, reject)=>{
    return axios.get('/portal/vue/YfPortalServlet',{params:{
        'action': 'List',
        'typeId': portId,
        'currPage':currPage,
		'contextFlg':'1',
    }}).then(result=>{
        resolve(result)
    })
})
}

export function getList({typeId,rowNum='10',imgFlg="0",contextFlg="0"}){
    return new Promise((resolve, reject)=>{
        axios.get('/portal/vue/YfPortalServlet',{params:{
            action: 'Index',
            typeId,rowNum,imgFlg,contextFlg
        }}).then(data=>{
            if(data.length>0){
                if(process.env.NODE_ENV==='development'){
                    const list = data[0].dt.map(e=>{
                        if(e.first_img.substring(0,4)!='http'){
                            e.first_img=process.env.VUE_APP_SECRET+e.first_img
                        }
                        return e
                    })
                    resolve(list)
                }else{
                    resolve(data[0].dt)
                }
                
            }else{
                resolve([])
            }
            
        })
    })
}
export function getColumn({typeId,rowNum='10',imgFlg="0",contextFlg="0"}){
    return new Promise((resolve, reject)=>{
        axios.get('/portal/vue/YfPortalServlet',{params:{
            action: 'Index',
            typeId,rowNum,imgFlg,contextFlg
        }}).then(result=>{
            resolve(result)
        })
    })
}


export function listSearch(string,currPage){
    return new Promise((resolve, reject)=>{
     axios.get('/portal/vue/YfPortalServlet',{params:{
        action: 'List',
        findInfo: string,
        currPage:currPage,
        contextFlg:'1'
    }}).then(result=>{
        resolve(result)
    })
})
}
